import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import { MutualModule } from '@shared/mutual/mutual.module';
import { PipesSharedModule } from '@shared/pipes-shared/pipes-shared.module';

import { RouteEditComponent, RouteViewComponent } from './components';
import { FormWrapperModule } from '@shared/form-wrapper/form-wrapper.module';

@NgModule({
  declarations: [RouteViewComponent, RouteEditComponent],
  imports: [CommonModule, MutualModule, PipesSharedModule, RouterModule, FormWrapperModule],
  exports: [RouteViewComponent, RouteEditComponent],
})
export class RoutesModule {}
